<h2
  mat-dialog-title
  style="background-color: #003366; color: white; padding: 10px"
>
  Duplicar feriados
</h2>
<mat-dialog-content
  style="display: flex; justify-content: space-around; padding: 20px"
>
  <div>
    <label>Año origen:</label>
    <input matInput type="number" [(ngModel)]="anioOrigen" />
  </div>
  <div>
    <label>Año destino:</label>
    <input matInput type="number" [(ngModel)]="anioDestino" />
  </div>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center; padding-bottom: 20px">
  <app-boton-primario
    boton_texto="Modificar"
    (boton_funcion)="onDuplicar()"
  ></app-boton-primario>
  <div style="margin-left: 10px">
    <app-boton-primario
      boton_texto="Cancelar"
      (boton_funcion)="onCancelar()"
      clase="red"
    ></app-boton-primario>
  </div>
</mat-dialog-actions>
